import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import {ListsContext} from '../App';

export default function TallyItem({item, index}) {
  const [removeDialogOpen, setRemoveDialogOpen] = React.useState(false);
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [newItemName, setNewItemName] = React.useState(item.name);

  return (
    <ListsContext.Consumer>
    {
      (context) => {
        return (
          <ListItem divider className="tally-item">
            <Fab aria-label="Decrement" onClick={() => context.updateCount(index, -1)} className="tally-btn">
              <RemoveIcon />
            </Fab>
            <ListItemText primary={
              <Typography component="div" variant="subtitle1" align="center" className="tally-name">
                {item.name}
              </Typography>
            } secondary={
              <Typography component="div" variant="h4" align="center" className="tally-count">
                {item.count}
              </Typography>
            } onClick={() => setEditDialogOpen(true)} />
            <Fab aria-label="Increment" onClick={() => context.updateCount(index, 1)} className="tally-btn" color="secondary">
              <AddIcon />
            </Fab>

            <Dialog
              open={editDialogOpen}
              onClose={() => setEditDialogOpen(false)}
              aria-labelledby="edititem-dialog-title"
              aria-describedby="edititem-dialog-description">
              <DialogTitle id="edititem-dialog-title">Edit item</DialogTitle>
              <DialogContent>
                <TextField
                  autoFocus
                  id="item-name"
                  defaultValue={item.name}
                  onChange={(event) => setNewItemName(event.target.value)} />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setRemoveDialogOpen(true)}>
                  Remove item
                </Button>
                <Button onClick={() => context.editItem(index, newItemName)} color="secondary">
                  OK
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={removeDialogOpen}
              onClose={() => setEditDialogOpen(false)}
              aria-labelledby="removeitem-dialog-title"
              aria-describedby="removeitem-dialog-description">
              <DialogTitle id="removeitem-dialog-title">Removing item</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure to remove this item?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setRemoveDialogOpen(false)} autoFocus>
                  Cancel
                </Button>
                <Button onClick={() => context.removeItem(index)} color="secondary">
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </ListItem>
        );
      }
    }
    </ListsContext.Consumer>
  );
}